import {
    Button,
    Heading,
    HStack,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Select,
    Stack,
    Textarea,
    VStack
} from '@chakra-ui/react';
import { IEditProfile, useEditProfile } from '../firebase';

interface ExperienceModalProps {
    endDate: string;
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
    profileId: string;
    startDate: string;
}

const ExperienceModal = ({
    endDate,
    isOpen,
    onClose,
    onOpen,
    profileId,
    startDate
}: ExperienceModalProps) => {
    const [startMonth, startYear] = startDate.split('/');
    const [endMonth, endYear] = endDate ? endDate.split('/') : ['', ''];
    let startMonthValue = startMonth ? setMonth(startMonth) : '';
    let startYearValue = startYear ? startYear.trim() : '';
    let endMonthValue = endMonth ? setMonth(endMonth.trim()) : '';
    let endYearValue = endYear ? endYear.trim() : '';

    const { mutate: edit } = useEditProfile(profileId);

    const accessToken = sessionStorage.getItem('accessToken') ?? '';
    const submitEdit = (e: any) => {
        const editedData: IEditProfile = {
            accessToken: accessToken,
            data: {}
            // data: profileStateEdited
        };
        edit(editedData, {
            onSuccess: () => {
                onClose();
            },
            onError: (error) => {
                console.error('edit failed.');
            }
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit Experience</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack w="100%">
                        <HStack w="100%">
                            <Heading
                                size="sm"
                                style={{
                                    color: 'var(--chakra-colors-midnight-500)',
                                    fontWeight: 700
                                }}
                            >
                                Title
                            </Heading>
                        </HStack>
                        <HStack w="100%">
                            <Input
                                placeholder="Examples: Marketing Intern, ENG 250 Final Project"
                                onChange={(event) => {
                                    // setProfileStateEdited({
                                    //     ...profileStateEdited,
                                    //     [titleKey]: event.target.value
                                    // });
                                }}
                            />
                        </HStack>
                        <HStack w="100%">
                            <Heading
                                size="sm"
                                style={{
                                    color: 'var(--chakra-colors-midnight-500)',
                                    fontWeight: 700
                                }}
                            >
                                Employer / School
                            </Heading>
                        </HStack>
                        <HStack w="100%">
                            <Input
                                placeholder="Where did you complete this experience?"
                                onChange={(event) => {
                                    // setProfileStateEdited({
                                    //     ...profileStateEdited,
                                    //     [employerKey]: event.target.value
                                    // });
                                }}
                            />
                        </HStack>
                        <HStack w="100%">
                            <HStack w="50%">
                                <Heading
                                    size="sm"
                                    style={{
                                        color: 'var(--chakra-colors-midnight-500)',
                                        fontWeight: 700
                                    }}
                                >
                                    Start Date
                                </Heading>
                            </HStack>
                            <HStack w="50%">
                                <Heading
                                    size="sm"
                                    style={{
                                        color: 'var(--chakra-colors-midnight-500)',
                                        fontWeight: 700
                                    }}
                                >
                                    End Date
                                </Heading>
                            </HStack>
                        </HStack>
                        <HStack w="100%">
                            <Select placeholder="Month" value={startMonthValue}>
                                <option value="Janurary">Janurary</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                            </Select>
                            <Select placeholder="Year" value={startYearValue}>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                            </Select>
                            <Select placeholder="Month" value={endMonthValue}>
                                <option value="Janurary">Janurary</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                            </Select>
                            <Select placeholder="Year" value={endYearValue}>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                                <option value="2009">2009</option>
                                <option value="2008">2008</option>
                                <option value="2007">2007</option>
                                <option value="2006">2006</option>
                                <option value="2005">2005</option>
                                <option value="2004">2004</option>
                                <option value="2003">2003</option>
                                <option value="2002">2002</option>
                                <option value="2001">2001</option>
                                <option value="2000">2000</option>
                            </Select>
                        </HStack>
                        <HStack w="100%">
                            <Heading
                                size="sm"
                                style={{
                                    color: 'var(--chakra-colors-midnight-500)',
                                    fontWeight: 700
                                }}
                            >
                                Description
                            </Heading>
                        </HStack>
                        <HStack w="100%">
                            <Textarea
                                onChange={(event) => {
                                    // setProfileStateEdited({
                                    //     ...profileStateEdited,
                                    //     [descriptionKey]: event.target.value
                                    // });
                                }}
                            />
                        </HStack>
                        <Stack w="100%" direction="row" spacing={4} justify="right">
                            <Button onClick={onClose}>Cancel</Button>
                            <Button variant="solid" onClick={submitEdit}>
                                Save
                            </Button>
                        </Stack>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ExperienceModal;

function setMonth(month: any): string {
    if (!isNaN(month)) {
        switch (month) {
            case '01':
                return 'January';
            case '02':
                return 'February';
            case '03':
                return 'March';
            case '04':
                return 'April';
            case '05':
                return 'May';
            case '06':
                return 'June';
            case '07':
                return 'July';
            case '08':
                return 'August';
            case '09':
                return 'September';
            case '10':
                return 'October';
            case '11':
                return 'November';
            case '12':
                return 'December';
            default:
                return 'January';
        }
    }

    return month;
}
